import { build } from './build-info';
import { AppEnvironment } from './environment.type';
import { getGatewayUrls } from './gateway.utils';

const gatewayUrls = getGatewayUrls('production');

export const environment: AppEnvironment = {
    build,
    BUILD_VERSION: build.branch,
    STAGE: 'production',
    origins: {
        ACCOUNT_ACCESS_URL: 'https://api.bannerflow.com/account-access',
        AD_SERVICE_URL: 'https://c.bannerflow.net',
        ANALYTICS_BACKEND_SERVICE_URL: 'https://api.bannerflow.com/ab',
        ANALYTICS_REPORT_SCHEDULER_SERVICE_URL: 'https://api.bannerflow.com/ars',
        API_GATEWAY_URL: 'https://api.bannerflow.com',
        APP_URL: gatewayUrls.APP_URL,
        B2_URL: 'https://b2.bannerflow.com',
        BFC_URL: gatewayUrls.BFC_URL,
        CAMPAIGN_MANAGER_URL: 'https://cm.bannerflow.com',
        CAMPAIGN_SERVICE_URL: 'https://api.bannerflow.com/cs',
        LIST_SERVICE_URL: 'https://api.bannerflow.com/list-service',
        MIGRATION_SERVICE_URL: 'https://migrationservice.bannerflow.com',
        NOTIFICATION_SERVICE_URL: 'https://api.bannerflow.com/notification-service/api',
        PUBLISH_SERVICE_URL: 'https://api.bannerflow.com/ps',
        SCHEDULE_MIGRATION_CLIENT_URL: 'https://smc.bannerflow.com',
        SOCIAL_ACCOUNT_SERVICE_URL: 'https://sas.bannerflow.com',
        SOCIAL_CAMPAIGN_MANAGER_URL: 'https://scm.bannerflow.com',
        SOCIAL_CAMPAIGN_SERVICE_URL: 'https://scs.bannerflow.com',
        STUDIO_URL: gatewayUrls.STUDIO_URL
    },
    GTM_ID: 'GTM-W5CTW5Z',
    INTERCOM_ID: 'vc7jxmzv',
    CLIENT_ID: 'pojemgnAOu2FiMJc3c9REcp2BMOxY1lL',
    LOGIN_URL: 'https://login.bannerflow.com',
    FEATURE_FLAG: {
        enabled: true,
        clientKey: '*:production.e8fba9035a116efe15a6eb6e71dd1cb860fac56cf5b26c369d7d9a4c'
    },
    NSSignalR: {
        enabled: true,
        url: 'https://api.bannerflow.com/notification-service/hub'
    }
};
